export default {"src":"/_next/static/media/icon-coin.cfd1d143.svg","height":29,"width":28};